module.exports = "/src/views/player/help/images/army.jpg";